import { useRef } from 'react';

export default function useFormSubmitFromHeader(onSubmit: (e: any) => void) {
  const formRef = useRef<HTMLFormElement | null>(null);

  const submitFromHeader = (e: any) => {
    if (formRef.current && !formRef.current.reportValidity()) {
      return;
    }
    onSubmit(e);
  };

  return { formRef, submitFromHeader };
}
